import type { Moment } from "moment";
import { ServiceRate } from "../../../lib/types";
import { getPriceUnitId } from "./getPriceUnitId";

interface Props {
  taxRate: string;
  isPacketTariff: boolean;
  currencyId: number | undefined;
}

export const getNewServiceRate = (props: Props) => {
  const { taxRate, isPacketTariff, currencyId } = props;
  const newRate: Partial<ServiceRate<Moment>> = {
    name: "",
    balanceTypeId: 1,
    conditionTypeId: 0,
    rateTypeId: undefined,
    priceUnitId: getPriceUnitId(isPacketTariff),
    taxRate,
    currencyId,
  };
  return newRate;
};
